export default __webpack_public_path__ + "static/media/gift-card.5b838d04.svg";